const setFavicon = (url) => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/png';
  link.rel = 'icon';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
};

const setWindowTitle = (title) => {
  window.document.title = title;
};



export default {
  setFavicon,
  setWindowTitle,
};



// WEBPACK FOOTER //
// ./src/helpers/tabInfo.js